import * as React from "react"
import {AmchartSeeker} from "@ui-seeker/core";

import {productDetailsEvolutionCurrentData, productDetailsEvolutionCurrentSellers} from "../@signals";


export default function MarketplacesProductDetailsEvolutionChart() {
    return <AmchartSeeker
        hiddenCard
        data={productDetailsEvolutionCurrentData.value}
        series={productDetailsEvolutionCurrentSellers.value.map(key => ({
            name: key,
            yField: key,
            xField: "date",
        }))}
        chartProps={{
            enabledPDF: false,
            numberFormat: `#,###.00`,
            xAxis: {
                categoryField: 'date',
                isDateAxis: true,
                title: 'Dates'
            },
            yAxis: {
                title: 'Price'
            }
        }}
    />
}